import type { GROQImage } from "@/sanity/lib/definitions";

export function coverImageSizes(image: GROQImage, widthRem: number, heightRem: number) {
  const aspectRatio = image.width > 0 && image.height > 0
    ? image.width / image.height
    : widthRem / heightRem;
  // Covering a portrait card can require more source pixels than its visible width.
  const width = Math.ceil(Math.max(widthRem, heightRem * aspectRatio) * 8);

  // HTML sizes resolves rem against the browser default, independently of our page scale.
  return `(max-width: 639px) ${width / 4.35}vw, (max-width: 992px) ${width}px, (max-width: 1920px) ${width / 19.2}vw, ${width}px`;
}
